import { render } from "./Zones.vue?vue&type=template&id=4158c617"
import script from "./Zones.vue?vue&type=script&lang=js"
export * from "./Zones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__